var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetgear({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 24,
    viewBox: "0 0 165 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.486 7.68346C162.486 2.89146 158.947 0.768005 154.288 0.768005H144.737V23.2423H150.87V14.5989H151.308L156.901 23.2423H164.363L157.325 14.0343C158.8 13.8271 160.146 13.0612 161.1 11.8866C162.055 10.712 162.549 9.21326 162.486 7.68346ZM152.448 10.8411H150.871V5.24108H152.628C154.642 5.24108 156.349 5.59428 156.349 8.04228C156.349 10.4903 154.462 10.8389 152.449 10.8389",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.563 0.770325L117.315 23.2447H123.658L125.004 19.1075H133.199L134.548 23.2447H140.885L132.642 0.770325H125.563ZM126.46 14.6378L129.014 6.79209H129.186L131.74 14.6378H126.46Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8898 23.2448H113.849V18.3007H105.029V14.415H113.476V9.47104H105.029V5.71908H113.848V0.768188H98.8887L98.8898 23.2448Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6135 15.2881H86.4457C86.1947 17.8858 84.3353 19.2001 81.6699 19.2001C77.6318 19.2001 75.6176 15.6435 75.6176 12.1567C75.6176 8.7281 77.3534 5.05497 81.4004 5.05497C82.5071 5.02904 83.5938 5.35995 84.5087 6.0014C85.4236 6.64284 86.1206 7.5627 86.5021 8.63212L92.3272 6.30748C90.2915 2.09948 86.5334 0 81.6835 0C74.0738 0 69.2448 4.81604 69.2448 12.1235C69.2448 19.1989 74.2257 24 81.6455 24C85.5981 24 88.892 22.6674 91.2031 19.584C93.3043 16.7806 93.5486 13.9841 93.613 10.6938H81.6189L81.6135 15.2881Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6724 5.72012H54.6093V23.2436H60.8443V5.72012H66.7871V0.769226H48.6724V5.72012Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6158 23.2448H44.5755V18.3007H35.7576V14.415H44.2057V9.47104H35.7554V5.71908H44.5733V0.768188H29.6136L29.6158 23.2448Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3599 14.512H16.2932L6.13476 0.770264H0V23.2457H6.13476V9.47436H6.20363L16.3599 23.2457H22.4936V0.770264H16.3599V14.512Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetgear);
export default __webpack_public_path__ + "static/media/netgear.14a78c0fb08a4e2136c90dead120c491.svg";
export { ForwardRef as ReactComponent };